export enum PaymentMethods {
    SWEDBANK = 'hanza',
    BANK_TRANSFER = 'bank_transfer',
    CARD = 'card',
    LUMINOR = 'nord',
    SIAULIU = 'sb',
    SEB = 'vb2',
    PAYSERA = 'wallet',
    LTHAND = 'lthand',
    CASH = 'cash',
    CREDIT_CONTRACT = 'credit_contract',
}